// extracted by mini-css-extract-plugin
module.exports = {"root__div":"Loading_root__div__jqD0d","loading__text":"Loading_loading__text__apG73"};